import { useMemo } from "react";

import useHttpActions from "shared/services/api/core/useHttpActions";
import type { BackendEntityType } from "shared/types";

import { getListMembersEPURL, getListMembersParamName } from "utils/getListMembersEPURL";

import BaseConverter from "./converters/baseConverter";

const useEntityManagementApiService = () => {
	const actions = useHttpActions();

	return useMemo(
		() => ({
			getEntityMembers: async <Response>({
				entity,
				id,
				limit,
				after
			}: {
				entity: BackendEntityType;
				id: string;
				limit?: number;
				after?: string;
			}) => {
				return BaseConverter.convert<Response>(
					await actions.get(getListMembersEPURL(entity), {
						[getListMembersParamName(entity)]: id,
						limit,
						after
					})
				);
			}
		}),
		[actions]
	);
};

export default useEntityManagementApiService;
